export const STATS_REQUEST = "STATS_REQUEST";
export const STATS_SUCCESS = "STATS_SUCCESS";
export const STATS_FAIL = "STATS_FAIL";
export const FETCH_PRICE_REQUEST = "FETCH_PRICE_REQUEST";
export const FETCH_PRICE_SUCCESS = "FETCH_PRICE_SUCCESS";
export const FETCH_PRICE_FAIL = "FETCH_PRICE_FAIL";
export const CHANGE_PRICE_SUCCESS = "CHANGE_PRICE_SUCCESS"; 
export const CLEAR_ERRORS = "CLEAR_ERRORS";